

import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './download.css';

const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const downloadItems = [
  { title: 'आरास नमुना १', description: 'मंदिर सजावटीसाठी उपयुक्त आरास नमुना डाउनलोड करा.',                          image: '/Assets/downloads/Seals111.png' },
  { title: 'आरास नमुना २', description: 'उत्सव आणि विशेष पूजा प्रसंगी वापरण्यासाठी आरास नमुना.',                    image: '/Assets/downloads/Seals222.png' },
  { title: 'आरास नमुना ३', description: 'भक्तांसाठी संदर्भ म्हणून ठेवलेला साधा आणि आकर्षक आरास नमुना.',             image: '/Assets/downloads/Seals333.png' },
  { title: 'आरास नमुना ४', description: 'विश्वस्त मंडळ आणि मंदिर ओळखीचा पारंपरिक चिन्ह नमुना.',                    image: '/Assets/downloads/Seals4.png' },
  { title: 'आरास नमुना ५', description: 'श्रीनाथ म्हस्कोबा थीमसाठी वापरता येईल असा प्रतीकात्मक नमुना.',             image: '/Assets/downloads/Seals555.png' },
  { title: 'आरास नमुना ६', description: 'मंदिर रचना आणि धार्मिक प्रतीकांसह सजावटीसाठी योग्य नमुना.',               image: '/Assets/downloads/Seals6.png' },
];

const brochureItems = [
  {
    title: 'पुनः प्राणप्रतिष्ठापना',
    description: 'महायज्ञ सोहळा व भव्य किर्तन महोस्तव.',
    image: '/Assets/home/kodit_temple.jpg',
    file: '/pdf/B1.pdf'
  },
  {
    title: 'पुनः प्राणप्रतिष्ठापना (ब्रह्मकलश सोहळा )',
    description: 'कलशोत्सव व महायज्ञ समारंभ तृतीय शुभमुहूर्तावर',
    image: '/Assets/home/kodit_temple.jpg',
    file: '/pdf/B2.pdf'
  }
];

const Download = () => {
  useScrollReveal('.download-scroll-item');
  useScrollReveal('.download-intro-scroll');

  const [showPdfModal, setShowPdfModal] = useState(false);
const [currentPdf, setCurrentPdf] = useState('');
const [currentTitle, setCurrentTitle] = useState('');

const openPdfModal = (pdfUrl, title) => {
  setCurrentPdf(pdfUrl);
  setCurrentTitle(title);
  setShowPdfModal(true);
};

const closePdfModal = () => {
  setShowPdfModal(false);
};

  return (
    <motion.div
      className="aaras-download-page"
      initial={{ opacity: 0, scale: 1.1 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7 }}
    >

      {/* ── CINEMATIC HERO ── */}
      <div className="aaras-download-hero">
        <div className="download-hero-bg" />
        <div className="download-hero-overlay" />
        <div className="download-hero-rays" aria-hidden="true">
          {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
        </div>
        <div className="download-hero-content">
          <span className="page-hero-pill">डाउनलोड</span>
          <h1 className="page-hero-title">आरास नमुने डाउनलोड करा</h1>
          <div className="page-hero-divider">
            <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
          </div>
        </div>
        <div className="page-hero-bottom-line" />
      </div>

      <div className="container">

        {/* Intro — parchment scroll */}
        <section className="download-intro-section">
          <div className="download-intro-scroll">
            <div className="download-intro-content">
              <h2 className="download-intro-title">आरास नमुने</h2>
              <div className="parchment-divider" />
              <p className="download-intro-text">
                मंदिराशी संबंधित चिन्हे, लोगो आणि आरास नमुने येथे डाउनलोडसाठी उपलब्ध आहेत.
              </p>
            </div>
          </div>
        </section>


        {/* Download Grid — each card = parchment scroll */}
        <section className="download-grid-section">
          <h2 className="section-title">नमुने</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>


{/* Brochure Cards */}
{/* Brochure Cards */}
<div className="brochure-grid">
  {brochureItems.map((item, index) => (
    <div className="brochure-card" key={index}>
      
      <img 
        src={item.image} 
        alt={item.title} 
        className="brochure-img"
      />

      <div className="brochure-content">
        <h3 className="brochure-title">{item.title}</h3>
        <p className="brochure-desc">{item.description}</p>

        <div className="brochure-buttons">
          <a 
            href={item.file} 
            download 
            className="brochure-btn download-btn"
          >
            ⬇ डाउनलोड
          </a>

          <button 
            className="brochure-btn view-btn"
            onClick={() => openPdfModal(item.file, item.title)}
          >
            👁️ ब्रॉवंचेर बघा 
          </button>
        </div>
      </div>

    </div>
  ))}
</div>


          <div className="download-grid">
            {downloadItems.map((item, index) => (
              <div className="download-scroll-item" key={index}>
                <div className="download-scroll-content">
                  <div className="download-image-wrap">
                    <img src={item.image} alt={item.title} loading="lazy" />
                  </div>
                  <h3 className="download-item-title">{item.title}</h3>
                  <div className="parchment-divider" />
                  <p >{item.description}</p>
                  <a href={item.image} download className="download-btn">
                    ⬇ डाउनलोड
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

      </div>







{/* PDF Viewer Modal */}
{showPdfModal && (
  <div className="pdf-modal-overlay" onClick={closePdfModal}>
    <div className="pdf-modal-content" onClick={e => e.stopPropagation()}>
      
      <div className="pdf-modal-header">
        <h3>{currentTitle}</h3>
        <button className="pdf-close-btn" onClick={closePdfModal}>✕</button>
      </div>

      <div className="pdf-modal-body">
        <iframe 
          src={currentPdf} 
          title={currentTitle}
          width="100%" 
          height="100%"
          style={{ border: 'none' }}
        />
      </div>

      <div className="pdf-modal-footer">
        <a href={currentPdf} download className="brochure-btn download-btn">
          ⬇ डाउनलोड करा
        </a>
      </div>

    </div>
  </div>
)}





    </motion.div>
  );
};

export default Download;